import { Link } from "react-router-dom";
import { MonoButton } from "../kits";
import { useState, useRef } from "react";

import RoughBorder from "../kits/LayoutKit/RoughBorder";

export default function ZenCard({ zen }) {
  const placeholder = "/images/b_gray-full.svg";
  const [isLoaded, setIsLoaded] = useState(false);
  const cardRef = useRef();

  return (
    <div ref={cardRef} className="relative">
      <Link
        to={`/zen/${zen.slug}`}
        className="h-full flex flex-col justify-between rounded-md p-4 transition-all bg-[#d0cbb8] border border-[#AC8E66]/25 hover:border-[#AC8E66]/45 hover:shadow-[0_0_0_1px_rgba(172,142,102,0.12)]"
      >
        {/* ... Card-Inhalt ... */}
        <div className="flex flex-col justify-start gap-1 flex-grow min-h-[132px]">
          <div className="text-sm font-mono text-left bg-[#1a1a1a] 
          border rounded-sm sm:rounded-md text-[#EFEBDC]
           font-normal tracking-tight min-h-[52px]">
            <p className="mt-1 px-2 line-clamp-2">{zen.title}</p>
          </div>
          <p className="text-[10px] leading-relaxed font-mono text-[#1a1a1a]/70 line-clamp-3 mt-4 px-3 min-h-[56px]">
            {zen.subtitle}
          </p>
        </div>
        <div className="relative w-full h-40 overflow-hidden rounded-lg mb-4">
          <img
            src={zen.image || placeholder}
            alt={zen.title || "Blogbild"}
            loading="lazy"
            onLoad={() => setIsLoaded(true)}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = placeholder;
            }}
            className={`object-cover w-full h-full transition-all duration-500
                bg-[#101010]
               pt-2 pb-2 pl-2 pr-2 rounded-md border border-[#AC8E66]/20 shadow-lg ${
              isLoaded ? "backdrop-blur-sm scale-100" : "blur-md scale-105"
            }`}
          />
        </div>
        <div className="mt-4">
          <MonoButton 
          className="w-full text-xs"
          textColor="text-[#EFEBDC]"
          underlineColors="ZenAmber"
          
          >
          
          
            Mehr ansehen
            
            </MonoButton>
        </div>
      </Link>
      <div>
      {/* RoughBorder GANZ außen! */}
      <RoughBorder
        parentRef={cardRef}
        radius={2}
        padding={3}
        color="#AC8E66"
        strokeWidth={0.8}
        roughness={1.5}
        bowing={1}
      />
      
      </div>
    </div>
  );
}
